import type { ForecastMarketPair } from '@/features/bidding/types/forecastPricing'

/**
 * Base colors for each market program.
 * Used for volume charts and other market-specific visualizations.
 */
export const MARKET_COLORS: Record<ForecastMarketPair, string> = {
  mfrr: '#3b82f6', // Blue-500
  'fcr-d': '#f97316', // Orange-500
  'fcr-n': '#8b5cf6', // Violet-500
  'opportunity-cost': '#6b7280', // Gray-500
}

/**
 * Get the base color for a market.
 */
export function getMarketColor(market: ForecastMarketPair): string {
  return MARKET_COLORS[market] ?? MARKET_COLORS.mfrr
}
